import axios from "axios";
import { getUserCredential } from "src/lib/cookies";
import projectSetting from "src/setting";

export const insertDocMessage = async (file, transactionId, uploadPathHeader, onProgress) => {
  const baseURL = projectSetting.baseURL + projectSetting.backend + projectSetting.version;
  const cookiesData = getUserCredential();

  const formData = new FormData();
  console.log("IsBlob", file instanceof Blob, file); // true
  formData.append("file", file, file.name);
  formData.append("in_transactionsrcmstrkey", transactionId);

  const response = await axios.post(`${baseURL}/conversation/insert-message-document`, formData, {
    headers: {
      "x-access-token": cookiesData?.secretToken || "",
      Accept: "application/json",
      uploadpath: `${uploadPathHeader}/conversation/`,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (event) => {
      if (onProgress && event.total) {
        const percent = Math.round((event.loaded / event.total) * 100);
        onProgress(percent);
      }
    },
  });

  onProgress?.(100);
  return response.data;
};
